import ReturnsMainPage from '@components/Returns/MainPage';
import Login from '@pages/Login.vue';
import { useUserStore } from '@stores/User';
import MemberEditorPage from '@pages/Public/MemberEditorPage.vue';
import WishlistPublicPage from '@pages/Public/WishlistPublicPage.vue';
import MemberUnsubscribePage from '@pages/Public/MemberUnsubscribePage.vue';
import WeddingListCreate from '@pages/Account/Wishlist/WeddingListCreate.vue';

export default [
    { path: '/login', name:'account.login', component: Login },
    {
        path: '/logout',
        name: 'account.logout',
        beforeEnter: (to, from, next) => {
            const user = useUserStore();
            user.logout();
            location.href = '/login';
        },
    },
    { path: '/account/wedding-list/create', name: 'account.weddingList.create', component: WeddingListCreate },
    { path: '/wishlist/:uuid', component: WishlistPublicPage, meta: { public: true } },
    { path: '/returns', component: ReturnsMainPage, meta: { public: true } },
    { path: '/u/edit/:shortMemberId?', component: MemberEditorPage, meta: { public: true }, name: 'u.edit' },
    // { path: '/unsubscribe/:shortMemberId?', component: MemberEditorPage, meta: { public: true }, name: 'u.unsubscribe' },
    { path: '/unsubscribe/:uuid', component: MemberUnsubscribePage, meta: { public: true }, name: 'u2.unsubscribe' },
    { path: '/u/:shortMemberId?', component: MemberEditorPage, meta: { public: true }, name: 'u.view' },
];
